module.exports = __webpack_public_path__ + "static/media/logo512.260d5758.png";